module.exports = __webpack_public_path__ + "static/media/obj-3.330e2c87.svg";